import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
const Toast = require('react-toast-mobile');


class RevisePassword extends React.Component <any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataList: [],
      password: '',
      newPassword: '',
    };
  }

  public btn = false;

  public componentDidMount() {
  }

  render() {
    return (
      <div>
        <ul className="password">
          <li>
            <div className="password-tit"><p>原密码</p></div>
            <input type="password" className="textmarket" placeholder="请输入原密码" maxLength={16} value={this.state.password || ''}  onChange={(e) => this.upState(e, 'password')   } />
          </li>
          <li>
            <div className="password-tit"><p>新密码</p></div><input type="password" className="textmarket"  placeholder="请输入新密码"  maxLength={16}   value={this.state.newPassword || ''}  onChange={(e) => this.upState(e, 'newPassword')   } />
          </li>
        </ul>
        <button className="password-btn"  style={{ background: "#dcdcdc" }}  onClick={() => this._updatePassword() }  >保&emsp;存 </button>
      </div>
    );
  }

  // 更新表单内容
  private upState(e: any, name: any) {
    switch(name) {
      case 'password':
        this.setState({ password: e.target.value }, () => upBtn())
        break;
        case 'newPassword':
        this.setState({ newPassword: e.target.value },() => upBtn())
        break;
    }

    const that = this;
    // 更新按钮状态
    function  upBtn() {
      if(that.state.password !== '' && that.state.newPassword !== '') {
        that.btn =  true;
        (document.querySelector('.password-btn') as any).style.background = '#3f87f7';
      }else {
        that.btn = false;
        (document.querySelector('.password-btn') as any).style.background = '#dcdcdc';
      }
    }

  }
  // 修改密码
  private async _updatePassword() {
    if(this.btn) {
      // 判断长度
      if(this.state.newPassword.length > 0 && this.state.newPassword.length <6 || this.state.newPassword.length > 32 ) {
        Toast.T.notify('输入的密码长度最低为6位！');
        return ;
      }
      if(!/^(?=.*\d)(?=.*[a-zA-Z])[a-zA_Z0-9]{6,16}$/gi.test(this.state.newPassword)) {
        Toast.T.notify('密码格式有误！请输入6-16字母与数字组合');
        return ;
      }
        // 判断重复密码
      if( this.state.password === this.state.newPassword) {
        Toast.T.notify('输入的密码重复！');
        return ;
      }
      // console.log('tijiao');
      const r = await request({
        method: 'post',
        data: {
          oldPwd: this.state.password,
          newPwd: this.state.newPassword,
        },
        url: `${config.API2}security/updatePwd`,
      })

      if(r.code === 1 ) {
        this.setState({
          password: '',
          newPassword: '',
        }, () => {
          Toast.T.notify('修改成功');
          setTimeout(() => {
            this.props.history.replace('/');
          }, 2500);
        });
        
      }else {
          Toast.T.notify(r.message);
      }

    }else {
      alert('您的密码输入有误！');
      return ;
    }

    
  }

}

export default RevisePassword;
